import { render } from "./MovePointModal.vue?vue&type=template&id=57699a4a&scoped=true"
import script from "./MovePointModal.vue?vue&type=script&lang=js"
export * from "./MovePointModal.vue?vue&type=script&lang=js"

import "./MovePointModal.vue?vue&type=style&index=0&id=57699a4a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57699a4a"]])

export default __exports__